module.exports = __webpack_public_path__ + "img/s_np_s_mu.baa29097.jpg";